/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_Bullet_SeniorInputs */

const en_marketing_engagement_bullet_senior = /** @type {(inputs: Marketing_Engagement_Bullet_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior engineering, no layers`)
};

const es_marketing_engagement_bullet_senior = /** @type {(inputs: Marketing_Engagement_Bullet_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingeniería sénior, sin intermediarios`)
};

const fr_marketing_engagement_bullet_senior = /** @type {(inputs: Marketing_Engagement_Bullet_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénierie senior, sans intermédiaires`)
};

/**
* | output |
* | --- |
* | "Senior engineering, no layers" |
*
* @param {Marketing_Engagement_Bullet_SeniorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_bullet_senior = /** @type {((inputs?: Marketing_Engagement_Bullet_SeniorInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_Bullet_SeniorInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_bullet_senior(inputs)
	if (locale === "es") return es_marketing_engagement_bullet_senior(inputs)
	return fr_marketing_engagement_bullet_senior(inputs)
});